import PageTitle from './PageTitle.component';

export default PageTitle;
